// Versión de producto: package.json (misma que PM2) + REACT_APP_VERSION en build de producción
import packageJson from '../../package.json';

const getCurrentVersion = () => {
  try {
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_VERSION) {
      return process.env.REACT_APP_VERSION;
    }
    return packageJson.version;
  } catch (error) {
    console.warn('Error obteniendo versión:', error);
    return packageJson.version;
  }
};

const APP_VERSION = getCurrentVersion();

export { APP_VERSION };
export const VERSION_LABEL = "Versión";

// Función para obtener el texto completo de la versión
export const getVersionText = () => {
  return `${VERSION_LABEL} ${APP_VERSION}`;
};

// Función para obtener solo el número de versión
export const getVersionNumber = () => {
  return APP_VERSION;
};

// Función para obtener solo el label de versión
export const getVersionLabel = () => {
  return VERSION_LABEL;
};